import { RegistrationStatusQuery } from '../graphql/generated';

type RegistrationStatusMe = RegistrationStatusQuery['me'] | null | undefined;

// An admin invite writes the users row up front, so a row alone no longer proves the
// person ever saw the registration form — only the registration stamp does.
export function hasCompletedRegistration(me: RegistrationStatusMe): boolean {
  return me?.registrationDate != null;
}

export type RegisterPrefill = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
};

// What the invite already knows about the person, keyed to the register form's control
// names. Blank values are omitted rather than patched, so a required field the admin
// left empty stays untouched and keeps its validator's dirty-state behaviour.
export function toRegisterPrefill(me: RegistrationStatusMe): RegisterPrefill {
  return {
    ...(me?.firstName?.trim() ? { firstName: me.firstName.trim() } : {}),
    ...(me?.lastName?.trim() ? { lastName: me.lastName.trim() } : {}),
    ...(me?.telephone?.trim() ? { phoneNumber: me.telephone.trim() } : {}),
  };
}
